module.exports = "/images/vendor/flag-icon-css/flags/1x1/pa.svg?beb40ab6cce7b2d196d2d4eb94848625";